<template>
  <template v-if="perspectives.length == 1">
    <BaseIcon
      size="18"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      :class="colorClassesForPerspective(perspectives[0]!, allPerspectives, 'icon')"
      >{{ iconForPerspective(perspectives[0]!) }}</BaseIcon
    >
  </template>
  <div
    v-if="perspectives.length == 2"
    class="text-on-primary-container absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-row gap-px"
  >
    <BaseIcon size="16" class="">{{ iconForPerspective(perspectives[0]!) }}</BaseIcon>
    <BaseIcon size="16" class="">{{ iconForPerspective(perspectives[1]!) }}</BaseIcon>
  </div>
  <div
    v-if="perspectives.length >= 3"
    class="text-on-primary-container absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2"
  >
    <BaseIcon size="16" class="absolute top-1.5 left-1/2 -translate-x-1/2">{{
      iconForPerspective(perspectives[0]!)
    }}</BaseIcon>
    <BaseIcon size="16" class="absolute bottom-2.5 left-1.5">{{
      iconForPerspective(perspectives[1]!)
    }}</BaseIcon>
    <BaseIcon size="16" class="absolute right-1.5 bottom-2.5">{{
      iconForPerspective(perspectives[2]!)
    }}</BaseIcon>
  </div>
</template>
<script lang="ts" setup>
  import {
    colorClassesForPerspective,
    iconForPerspective,
  } from '@/core/models/feedback-perspective'
  import BaseIcon from '../../base/icon/BaseIcon.vue'
  import type { Perspective } from '@/core/models/perspective.ts'

  defineProps<{
    perspectives: Perspective[]
    allPerspectives: ReadonlyArray<Perspective>
  }>()
</script>
